/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

// 我的会员列表
export const MY_MEMBER_LIST_PAGE_UUID = '539dfead-bf4b-4e5a-897b-55fe12c6ceaa'
